module.exports = __webpack_public_path__ + "static/scenario-offer-example-a21ee65c14b485faf7836e769a611ad3.png";